/* eslint-disable max-len */
/* eslint-disable no-restricted-syntax */
import { getByNameOrSymbol } from './coins.js';

const DEFAULT_FALLBACK = {
    name: 'bitcoin',
    blockchains: ['BTC'],
    addressFormat: ['all'],
    network: 'prod',
};

/**
 * Checks if a given address is valid for the given currency
 *
 * @param {String} address The target address
 * @param {Array} blockchains A list of blockchain names
 * @param {String} networkType Network Type. Could be 'prod', 'both' and 'testnet'
 * @param {Array} addressFormats Array of formats. For example ['legacy', 'slp ', 'cash']
 * @returns {Array of Booleans}
 */

export const WalletAddressValidator = async (address, blockchains, self) => {
    const validatedBlockchains = {};

    for await (const blockchain of blockchains.map((blockchainSymbol) => getByNameOrSymbol(blockchainSymbol))) {
        const blockchainSymbolUpper = blockchain.symbol.toUpperCase().trim();

        validatedBlockchains[blockchainSymbolUpper] = await blockchain.validator.isValidAddress(
            address,
            blockchain,
            DEFAULT_FALLBACK.network, // some legacy validators use this
            DEFAULT_FALLBACK.addressFormat, // some legacy validators use this
            self,
        );
    }

    return validatedBlockchains;
};

export default { WalletAddressValidator };
